import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Alert,
  Box,
} from '@mui/material';
import axios from 'axios';

const OrderModal = ({ open, onClose, product }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handlePhoneChange = (e) => {
    const val = e.target.value;
    if (
      (val.length === 0 ||
        (val[val.length - 1] >= '0' && val[val.length - 1] <= '9') ||
        (val.length === 1 && val[0] === '+')) &&
      val.length <= 12
    ) {
      setPhone(val);
    }
  };

  const handleSubmit = async () => {
    if (!name.trim() || !phone.trim()) return;
    setLoading(true);
    setError(null);
    try {
      await axios.post('/shop', {
        productsId: [product.id],
        user: {
          firstName: name,
          lastName: '',
          email: phone,
          phone: phone,
        },
        address: '',
        paymentMethod: 'Звонок',
        comment: comment || 'empty',
      });
      setSuccess(true);
    } catch (err) {
      setError('Не удалось оформить заказ. Попробуйте позже.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setName('');
    setPhone('');
    setComment('');
    setSuccess(false);
    setError(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>
        {success ? 'Заказ принят' : 'Оформить заказ'}
      </DialogTitle>
      <DialogContent>
        {success ? (
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <Typography variant="h6" color="success.main" gutterBottom>
              Спасибо!
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Менеджер перезвонит вам в течение часа для подтверждения заказа.
            </Typography>
          </Box>
        ) : (
          <>
            <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
              <Typography variant="subtitle1" fontWeight={600}>
                {product.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {product.fullName}
              </Typography>
              <Typography variant="h6" sx={{ mt: 1, color: '#1a1a1a' }}>
                {product.calculatedPrice?.toLocaleString('ru-RU')} ₽
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                Оператор свяжется с вами в ближайшее время
              </Typography>
            </Box>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <TextField
              label="Имя"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              required
              sx={{ mb: 2, '& .MuiInputBase-root': { minHeight: 48 } }}
            />
            <TextField
              label="Телефон"
              value={phone}
              onChange={handlePhoneChange}
              placeholder="+7 ___ ___-__-__"
              fullWidth
              required
              sx={{ mb: 2, '& .MuiInputBase-root': { minHeight: 48 } }}
            />
            <TextField
              label="Комментарий"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              fullWidth
              multiline
              rows={3}
              placeholder="Цвет, аксессуары, вопросы..."
              sx={{ '& .MuiInputBase-root': { minHeight: 80 } }}
            />
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        {success ? (
          <Button onClick={handleClose} variant="contained" fullWidth size="large">
            Хорошо
          </Button>
        ) : (
          <>
            <Button onClick={handleClose} disabled={loading}>
              Отмена
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              color="success"
              disabled={loading || !name.trim() || !phone.trim()}
              size="large"
            >
              {loading ? 'Отправка...' : 'Оформить'}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default OrderModal;
